import React, { useState, useEffect } from 'react'
import { useShared } from '../../hooks/useShared';
import { useParams } from 'react-router-dom';
import ABreadcrumbs from '../../components/breadcrumbs/ABreadcrumbs';
import { Avatar, Card, Chip } from '@material-tailwind/react';
import UserTariffTable from './user_view/UserTariffTable';
import UserInvoiceTable from './user_view/UserInvoiceTable';
import ASpinner from '../../components/partials/ASpinner';


export default function EmployeeView() {
    const { http, com, setPhoto, setModel, model,consts} = useShared();
    const [loading, setLoading] = useState(false)
    const { id } = useParams();

    useEffect(() => {
        if (id > 0) {

            setModel(null)
            setLoading(true)
            http.get(`/api/users/${id}`).then(res => {
                console.log('ViewUser get user data ', res);
                if (res.data.success && res.data.data) {
                    const data = res.data.data;
                    setModel(data)
                    const img = data?.image_data?.path
                    setPhoto({ url: img ? consts.BASE_URL + img : '', photo: null })

                }
                setLoading(false)

            }, err => {
                console.log('err');
                setLoading(false)
            })
        }
    }, [])


    const userView = (obj) => {
        return [
            { l: 'اسم', v: obj?.fname },
            { l: 'تخلص', v: obj?.lname },
            { l: 'شماره تماس', v: obj?.phone },
            { l: 'ايمیل', v: obj?.email },
            { l: 'نقش', v: obj?.roles?.map((p, i, arr)=> <span> {p.label} {i !== (arr.length-1) ? ',' : ''}</span> ) },
            { l: 'مقام', v: obj?.position?.map((p, i, arr)=> <span> {p.label} {i !== (arr.length-1) ? ',' : ''}</span> ) },
            { l: 'معاش', v: obj?.salary },
            { l: 'زون', v: obj?.zone?.label },
            { l: 'تاریخ عضويت', v: obj?.joining_date },
            { l: 'ثبت کننده', v: obj?.user?.full_name },
            { l: 'حالت', v: obj?.status },
            { l: 'ملاحظات', v: obj?.description },
            { l: 'تاريخ', v: com.dateConvert(obj?.updated_at, false, true) },
            { l: 'عکس', v: obj?.image_data ? consts.BASE_URL + obj?.image_data?.path : consts.DEFULAT_USER_PHOTO },
        ]
    }

    const companyView = (obj) => {
        return [
            { l: 'نام', v: obj?.name_af },
            { l: 'نام انگلسی', v: obj?.name_en },
            { l: 'شماره جواز', v: obj?.license_number },
            { l: 'TIN شماره', v: obj?.tin_number },
            { l: 'تاريخ تائسيس', v: com.dateConvert(obj?.establishment_date, false) },
            { l: 'ادرس', v: obj?.address },
            { l: 'ثبت کننده', v: obj?.user?.full_name },
            { l: 'حالت', v: obj?.status },
            { l: 'تاريخ ثبت', v: com.dateConvert(obj?.updated_at, false, true) },
            { l: 'لوگو', v: obj?.image_data ? consts.BASE_URL + obj?.image_data.path : consts.DEFULAT_USER_PHOTO },
        ]
    }

    const userInfo = ({ l, v }) => {
        return <> <td className='text-black text-sm'>{l}</td>
            {l === 'حالت' ? <td><Chip className='capitalize text-center w-fit' variant="ghost" size="sm" color={v === 1 ? 'green' : 'red'} value={v === 1 ? 'فـعـال' : 'غير فعال'} /></td> :
                <td className='col-span-2'>{v}</td>}</>
    }

    const logo = (o) => {
        console.log(o)
        return(
        <><td className="text-black text-sm">{o.l} </td>
            <td className="col-span-2">
                <Avatar size="xxl" variant="rounded" withBorder={true} color="red"
                    src={o.v}
                    alt="Image"
                    className=" p-0.5" />
            </td> </>
    )}

    return (
        <div>
            <ABreadcrumbs links={[{ name: 'کاربران', link: '/users' }, { name: 'معلومات کاربر', link: '' }]} />
            {loading ? <ASpinner /> : <div className='grid md:grid-cols-2 gap-4'>
                <Card className="p-2 md:p-4 mt-4 relative">
                    <div className='text-main-color font-bold border-b mb-2'>معلومات کارمند</div>
                    <table className='gTable'>
                        <tbody>
                            {userView(model)?.map((o, i) => (<tr key={i} className='text-sm'>  {o.l === "لوگو" || o.l === "عکس" ? logo(o) : userInfo(o)}</tr>))}
                        </tbody>
                    </table>

                </Card>

                {model?.companies && model?.companies?.length > 0 &&
                    <Card className="p-2 md:p-4 mt-4 relative">
                        <div className='text-main-color font-bold border-b mb-2'>معلومات شرکت</div>
                        <table className='gTable'>
                            <tbody>
                                {companyView(model?.companies[0])?.map((o, i) => (<tr key={i} className='text-sm'>  {o.l === "لوگو" || o.l === "عکس" ? logo(o) : userInfo(o)}</tr>))}
                            </tbody>
                        </table>

                    </Card>}
            </div>
            }
            {model?.companies && <UserTariffTable v={{ company_id: model.companies[0]?.id }} />}
             {model?.companies && <UserInvoiceTable v={{ company_id: model.companies[0]?.id }} />}
        </div>
    )
}
